<template>
  <div class="main-content">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>消息中心</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="main-table">
      <el-container>
        <el-aside width="160px">
          <div :class="{ active: messageIndex === 0 }"
            @click="messageIndex = 0; pageparm.currentPage = 1; getMessageList()">全部</div>
          <div :class="{ active: messageIndex === 1 }"
            @click="messageIndex = 1; pageparm.currentPage = 1; getMessageList()">已读</div>
          <div :class="{ active: messageIndex === 2 }"
            @click="messageIndex = 2; pageparm.currentPage = 1; getMessageList()">未读</div>
        </el-aside>
        <el-main>
          <div class="message-list">
            <div class="message-item" v-for="item in messageList" :key="item.sourceId" >
              <el-badge :is-dot="!item.isRead" class="item">
                <img src="@/assets/img/messageIcon.svg" alt="" srcset="">
              </el-badge>
              <div class="d-flex flex-column flex-justify-between item-content">
                <div>
                  {{ item.title }}
                </div>
                <span>{{ item.content }}</span>
              </div>
              <div class="d-flex flex-column flex-justify-between item-desc">
                <div>{{ item.createTime }}</div>
                <span @click="goDetails(item)" v-buttonAuth="'system:messageCenter:details'">查看></span>
              </div>
            </div>
          </div>
          <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </div>
        </el-main>
      </el-container>
    </div>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { messagePage } from '@/api/message.js'
import { get } from '../../api/axiosFun'
export default {
  components: {
    Pagination,
  },
  data () {
    return {
      messageIndex: 0,
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      messageList:[],
    }
  },
  created () {
    this.getMessageList()
  },
  methods: {
    getMessageList () {
      const pararms = {
        isRead: this.messageIndex === 0 ? null : this.messageIndex == 1 ? true : false,
        pageNum: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      };
      messagePage(pararms).then(res => {
        this.messageList = res.data.records;
        this.pageparm.total = res.data.total;
      })
    },
    callFather (parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize;
      this.getMessageList()
    },
    goDetails (item) {
      this.$router.push({
        path:'/message/messageDetails',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-breadcrumb {
  padding-bottom: 10px;
}

.main-table {
  border-top: 1px solid #eee;

  .el-container {
    height: 100%;
  }

  .el-aside {
    border-right: 1px solid #eee;
    height: 100%;

    div {
      font-size: 22px;
      color: #000000;
      padding: 12px 20px;
      box-sizing: border-box;
      text-align: center;
      cursor: pointer;

      &:hover {
        background-color: rgb(41, 52, 70, 0.1);
      }

      &.active {
        background-color: rgb(41, 52, 70, 0.1);

      }
    }
  }

  .el-main {
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .message-list {
      flex: 1;
      flex-basis: 0;
      overflow-y: auto;

      .message-item {
        width: 100%;
        background: inherit;
        background-color: rgba(255, 255, 255, 1);
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(121, 121, 121, 1);
        border-radius: 0px;
        box-shadow: none;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 10px;
        margin-bottom: 13px;

        img {
          width: 50px;
          height: 50px;
        }

        .item-content {
          flex: 1;
          padding-left: 5px;

          div {
            font-size: 26px;
          }

          span {
            font-size: 17px;
            padding-left: 20px;
          }
        }

        .item-desc {
          span {
            font-size: 16px;
            color: #0400CC;
            cursor: pointer;
            text-align: right;
          }

          div {
            font-size: 15px;

          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/message/messageCenter.vue